import { PropsWithChildren } from 'react';
import {
  styContainer,
} from './style';
import { InfoCardPropType } from './type';

export function CustomInfoCard({
  width = 450,
  height = 300,
  margin,
  children,
}: PropsWithChildren<Pick<
InfoCardPropType,
'width' | 'height' | 'margin'>>) {
  return (
    <div
      css={styContainer}
      style={{
        width,
        minHeight: height,
        margin,
      }}
    >
      {children}
    </div>
  );
}
